"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTLLanguages = exports.EnabledLanguages = void 0;
var EnabledLanguages;
(function (EnabledLanguages) {
    EnabledLanguages["EN"] = "EN";
    EnabledLanguages["RU"] = "RU";
})(EnabledLanguages || (exports.EnabledLanguages = EnabledLanguages = {}));
var RTLLanguages;
(function (RTLLanguages) {
    RTLLanguages["AR"] = "AR";
})(RTLLanguages || (exports.RTLLanguages = RTLLanguages = {}));
//# sourceMappingURL=language.js.map